import { useState } from "react";
import { api, HelpTopic } from "../lib/api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Info, X } from "lucide-react";

interface Props {
  anchor: string;
  inline?: boolean;
}

export function HelpButton({ anchor, inline = true }: Props) {
  const [open, setOpen] = useState(false);
  const [topic, setTopic] = useState<HelpTopic | null>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function toggle() {
    if (open) {
      setOpen(false);
      return;
    }
    setOpen(true);
    if (topic) return;
    setLoading(true);
    setErr(null);
    try {
      const t = await api.get<HelpTopic>(`/api/v1/help/${encodeURIComponent(anchor)}`);
      setTopic(t);
    } catch (e: any) {
      setErr(e?.detail || e?.message || "помилка");
    } finally {
      setLoading(false);
    }
  }

  return (
    <span style={{ position: "relative", display: inline ? "inline-block" : "block" }}>
      <button
        onClick={toggle}
        title="Що це?"
        aria-label={`Допомога: ${anchor}`}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 2,
          color: "#4299e1",
          verticalAlign: "middle",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <Info size={14} />
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            zIndex: 100,
            width: 320,
            maxWidth: "85vw",
            padding: 14,
            background: "white",
            border: "1px solid #cbd5e0",
            borderRadius: 6,
            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            color: "#1f2937",
            fontSize: 13,
            lineHeight: 1.5,
            textAlign: "left",
          }}
        >
          <button
            onClick={() => setOpen(false)}
            style={{
              position: "absolute",
              top: 6,
              right: 6,
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#a0aec0",
              padding: 2,
            }}
            aria-label="Закрити"
          >
            <X size={14} />
          </button>
          {loading && <div style={{ color: "#718096" }}>Завантаження…</div>}
          {err && <div style={{ color: "#c53030" }}>Помилка: {err}</div>}
          {topic && (
            <>
              <strong style={{ display: "block", marginBottom: 6, color: "#1a365d" }}>
                {topic.title}
              </strong>
              <div style={{ fontSize: 12.5 }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {topic.body_md.length > 600
                    ? topic.body_md.slice(0, 600) + "…"
                    : topic.body_md}
                </ReactMarkdown>
              </div>
              <a
                href={`/methodology#${anchor}`}
                style={{
                  display: "inline-block",
                  marginTop: 8,
                  fontSize: 12,
                  color: "#2c5282",
                  textDecoration: "none",
                }}
              >
                Детальніше →
              </a>
            </>
          )}
        </div>
      )}
    </span>
  );
}
